/**
 * Single course comment.
 */
import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { VText, VAvatar } from "form";
import SafeHtml from "pages/common/SafeHtml";
import { asArray, asObject } from "utils/safeData";

/**
 * Comment card with edit support.
 *
 * @param {{ comment: Object }} props
 */
const CourseCommentItem = (props) => {
  const { t } = useTranslation("common");

  const comment = asObject(props.comment);
  const replies = asArray(comment.reply);

  return (
    <Box key={comment._id}>
      <Box className="flex border border-solid border-orange-600 rounded-[45px] md:mb-4 mb-2.5 p-2" key={comment._id}>
        <VAvatar src={comment.avatar} className="w-20 h-20" />
        <Box className="p-4 flex flex-col gap-1">
          <Box>
            <VText className="font-bold">{comment.author_fullname}</VText>
            <VText className="text-sm rounded bg-gray-100 dark:bg-gray-700 px-2 py-1 ml-4">{t(comment.role)}</VText>
          </Box>
          <VText className="text-lg v-child-p dark:text-gray-300">
            <SafeHtml html={comment.body} />
          </VText>
        </Box>
      </Box>

      {replies.map((reply) => (
        <Box className="flex ml-8 mb-4" key={reply.created_at}>
          <VAvatar src={reply.avatar} className="w-10 h-10" />
          <Box className="ml-4 flex flex-col">
            <Box>
              <VText className="font-bold">{reply.author_fullname}</VText>
              {reply.role && <VText className="text-sm rounded bg-gray-100 px-2 py-1 ml-4">{reply.role}</VText>}
            </Box>
            <VText className="text-lg text-limit-1 v-child-p dark:text-gray-300">
              <SafeHtml html={reply.body} />
            </VText>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

CourseCommentItem.propTypes = {
  comment: PropTypes.object,
};

export default CourseCommentItem;
